import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_giftcard_claim = _resolveComponent("giftcard-claim")!
  const _component_main_layout = _resolveComponent("main-layout")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_common_button = _resolveComponent("common-button")!
  const _component_common_modal = _resolveComponent("common-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_spin, {
      spinning: _ctx.isSpinRef,
      indicator: _ctx.indicator,
      tip: _ctx.t('loading'),
      wrapperClassName: _ctx.isSpinRef ? 'ant-spin-loading-custom-class' : ''
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_config_provider, { autoInsertSpaceInButton: false }, {
          default: _withCtx(() => [
            _createVNode(_component_main_layout, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view),
                _createVNode(_component_giftcard_claim, {
                  cardInfos: _ctx.unclaimedGiftCardsRef,
                  "onUpdate:cardInfos": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.unclaimedGiftCardsRef) = $event))
                }, null, 8 /* PROPS */, ["cardInfos"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["spinning", "indicator", "tip", "wrapperClassName"]),
    _createCommentVNode(" 强制登录提示 "),
    _createVNode(_component_common_modal, {
      visible: _ctx.isLoginRequiredModalVisibleRef,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isLoginRequiredModalVisibleRef) = $event)),
      closable: false,
      maskClosable: false,
      width: "275px"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('loginRequired')), 1 /* TEXT */)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_common_button, {
          width: "235px",
          type: "primary",
          size: "middle",
          onClick: _ctx.handleLoginRequired
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('goToLogin')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(_ctx.t('loginRequiredMessage')) + " ", 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ], 64 /* STABLE_FRAGMENT */))
}